import { render, staticRenderFns } from "./CreateIncidentReport.vue?vue&type=template&id=74f11da8&"
import script from "./CreateIncidentReport.vue?vue&type=script&lang=js&"
export * from "./CreateIncidentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports